module.exports = __webpack_public_path__ + "img/shou1_b2e0c5483.png";